import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DefaultLoader from '../../components/loader/DefaultLoader';
import {useCookies} from 'react-cookie';
import ballImage from '../../assets/img/icon/ball_icon.png';
import dateSetting from '../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import TrackmanHitCourseChart from '../../components/chart/TrackmanHitCourseChart';
import _ from 'lodash';

function SprayTrackmanChartMain({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [sprayData, setSprayData] = useState([]);
    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let [colorType, setColorType] = useState('hitResult');
    let [checkObj, setCheckObj] = useState({
        Fastball: true, Sinker: true, Cutter: true, Slider: true,
        Curveball: true, ChangeUp: true, Splitter: true, Other: true
    });

    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();
    let useLang = localStorage.getItem('language');

    const ballCodeArr = [
        {name: 'fastball', code: 'Fastball', color: '#ff0000'}, {name: 'sinker', code: 'Sinker', color: '#ff7800'}, 
        {name: 'cutter', code: 'Cutter', color: '#00ff00'}, {name: 'slider', code:'Slider', color: '#00aa00'},
        {name: 'curve', code: 'Curveball', color: '#000000'}, {name: 'changeup', code: 'ChangeUp', color: '#0000ff'}, 
        {name: 'splitter', code: 'Splitter', color: '#a01ff0'}, {name: 'other', code:'Other', color: '#ececec'}
    ]

    useEffect(() => {
        let {playerId} = profile;

        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresTrackManLogRecord',
                batterIds: playerId,
                seasons: season,
                // gameTypeCodes: 4206,
                leagueTypeCodes: 'KBOFutures',
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            let data = _.map(result['data']['result']['record'], (item, idx) => {
                let {b1b, b2b, b3b, hr, fo, go} = item;
                if(b1b) {
                    item['hitResultCode'] = 6604;
                } else if(b2b) {
                    item['hitResultCode'] = 6607;
                } else if(b3b) {
                    item['hitResultCode'] = 6610;
                } else if(hr) {
                    item['hitResultCode'] = 6613;
                } else if(fo) {
                    item['hitResultCode'] = 6602;
                } else if(go) {
                    item['hitResultCode'] = 6605;
                }

                item['ballCode'] = item['taggedPitchType'];

                return item;
            });
            setSprayData(data);
        })
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setSeason(value);
    }

    function typeCodeHandler(event) {
        setColorType(event.target.value);
    }

    function ballCodeCheckHandler(event) {
        let id = event.currentTarget.id;
        let idSplit = id.split('-');
        let ballCode = idSplit[1];
        let checkStatus = checkObj[ballCode];

        setCheckObj({...checkObj, [ballCode]: !checkStatus})
    }

    // if(sprayData.length === 0 ) {
    //     return <DefaultLoader />
    // }

    return (
        <>
        <div style={{position:'absolute', top: '7px', left: '7px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle">
            <img src={ballImage} style={{height:'25px'}} /> {t('sprayChart')}(T)
        </div>
        <div style={{textAlign:'center'}}>
            <TrackmanHitCourseChart data={sprayData} ballCodeArr={ballCodeArr} 
            colorType={colorType} checkObj={checkObj}/>
        </div>
        <div style={{textAlign:'center'}}>
            <div style={{display:'inline-block', paddingRight: '5px'}}>{t('color')}</div>
            <div style={{display:'inline-block'}}>
                <Form.Group onChange={typeCodeHandler} style={{display:'inline-block', height: '29px'}}>
                    <Form.Select size="sm" defaultValue={'hitResult'}>
                        <option value='hitResult'>{t('hitResult')}</option>
                        <option value='ballCode'>{t('ballType')}</option>
                    </Form.Select>
                </Form.Group>
            </div>
        </div>
        <div>
        <Form>
            <div style={{display:'flex', flexWrap: 'wrap', 
            justifyContent: 'center', marginTop:'5px'}}>
            {ballCodeArr.map((item, idx) => (
                <div style={ useLang === "en" 
                    ? {width:'92px', border: `1px solid ${item['color']}`, 
                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                        fontSize: '13px', textAlign:"center"} 
                    : {width:'85px', border: `1px solid ${item['color']}`, 
                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                        fontSize: '13px'}}
                key={`check-${item['code']}`}
                onClick={ballCodeCheckHandler}
                id={`div-${item['code']}`}
                >
                    <Form.Check size='sm'
                    checked={checkObj[item['code']]}
                    readOnly
                    // onChange={ballCodeCheckHandler}
                    inline
                    name="group1"
                    type={'checkbox'}
                    id={`check-${item['code']}`}
                    width={'100px'}
                    style={useLang === "en" ? { marginRight:"5px", float:"left"} : {}}
                    />
                {t(item['name'])}
                </div>
            ))}
            </div>
        </Form>
        </div>
        </>
    )
}

export default SprayTrackmanChartMain;